const AdQueryKeys = {
  global: ["ads"] as const,
  list: (params: { [key: string]: number | string }) =>
    [...AdQueryKeys.global, "list", params] as const,
  impression: (url: string) =>
    [...AdQueryKeys.global, "impression", url] as const,
};

export { AdQueryKeys };
